export default __webpack_public_path__ + "static/media/keto_monitor_health@3x.2d837bbd.jpg";